/**
* Web Service handler to retrieve and represent a list of Appointment Custom Screens
* for the selected location
*
* @class AppointmentCustomScreensWS
*/
function AppointmentCustomScreensWS (parent) {
	var self = this;

	AbstractWS.apply( this, arguments );

	

	self.locationId				= ko.observable( null );
	self.name					= 'AppointmentCustomScreensWS';
	self.partySize				= ko.observable( null );
	self.screens				= ko.observableArray( [] );


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL = ko.computed( function () {
		return '/qless/api/v1/kiosk/location/' + self.locationId() + '/appointmentCustomScreens';
	});


	/**
	* Returns all the fields for all appointment custom screens
	*
	* @method fields
	* @return {Array}
	*/
	self.fields = ko.computed( function () {
		return self.screens().reduce( function ( arr, scrn ) {
			arr = arr.concat( scrn.fields() );
			return arr;
		}, [] );
	});


	/**
	* Request data from the API service
	*
	* @method doRequest
	* @param {Number} locationId
	* @return none
	*/
	self.doRequest = function ( locationId ) {
		qcal.setStatusMessage('Requesting appointment custom screens');

		self.locationId( locationId );

		if ( self.partySize() != null ) {
			self.addParam( 'partySize', self.partySize() );
		}

		AbstractWS.prototype.doRequest.call(self);
	};


	/**
	* Converts XML returned from the API into a collection of CustomScreenModels
	*
	* @method processData
	* @param {XMLDocument} xmlData
	* @return none
	*/
	self.processData = function ( xmlData ) {
		var aTemp = [],
			i = 0,
			scrns = [];

		qcal.setStatusMessage('Appointment custom screens received', 1000);

		AbstractWS.prototype.processData.call(self, xmlData);

		self.screens.removeAll();

		scrns = $(xmlData).find('screen').toArray() || [];

		for ( i = 0; i < scrns.length; i++ ) {
			aTemp.push( new CustomScreenModel( scrns[i] ) );
		}

		self.screens( aTemp );
	};

	return self;
};

AppointmentCustomScreensWS.prototype = AbstractWS.prototype;
AppointmentCustomScreensWS.prototype.constructor = AppointmentCustomScreensWS;
